import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import DashboardModal from '../components/reports/DashboardModal';

/**
 * Stand-alone landing page for the dashboard, reachable directly
 * (/reports/dashboard) and through the key-login deep link
 * (e.g. /authentication/<key>/dashboard). It hosts the existing
 * DashboardModal opened on top of an empty backdrop; closing it returns home.
 */
const DashboardScreen = (props) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    useEffect(() => {
        props.changeScreen && props.changeScreen('reports');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <DashboardModal
                open={open}
                onClose={() => { setOpen(false); navigate('/' + props.lang + '/home'); }}
                api={props.api}
                t={props.t}
            />
        </Box>
    );
};

export default DashboardScreen;
